import React from "react";
import { Content, Container } from "./style";
import Navbar from "../Navbar";
import { Outlet } from "react-router-dom";

export default () => {
  return (
    <>
      <Container>
        <Navbar />
        <Content>
          <Outlet />
        </Content>
      </Container>
    </>
  );
};
